import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fef83d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "data-cy", "data-question-id"]
const _hoisted_2 = {
  key: 1,
  width: "21",
  height: "5",
  viewBox: "0 0 23 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDropDown = _resolveComponent("CustomDropDown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: _ctx.idPopover,
      "data-cy": _ctx.dataCyId,
      "data-question-id": _ctx.dataQuestionId,
      tabindex: 0,
      class: _normalizeClass(`${_ctx.classes} tw-cursor-pointer action-button tw-relative ${
      _ctx.isFromNotification ? 'tw-px-[0px]' : 'tw-p-[20px]'
    }`),
      onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-hover', false))),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal(!_ctx.showMoreActions)))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass({
        'three-dots-wrapper tw-cursor-pointer': true,
        '!tw-cursor-not-allowed': _ctx.disabled,
        iconClass: _ctx.iconClass,
      })
      }, [
        (_ctx.hasSlot('icon'))
          ? _renderSlot(_ctx.$slots, "icon", { key: 0 }, undefined, true)
          : (_openBlock(), _createElementBlock("svg", _hoisted_2, [
              _createElementVNode("circle", {
                cx: "2.5",
                cy: "2.54562",
                r: "2.5",
                fill: _ctx.isFromNotification ? '#B7B7B7' : '#878787'
              }, null, 8, _hoisted_3),
              _createElementVNode("circle", {
                cx: "11.5",
                cy: "2.54562",
                r: "2.5",
                fill: _ctx.isFromNotification ? '#B7B7B7' : '#878787'
              }, null, 8, _hoisted_4),
              _createElementVNode("circle", {
                cx: "20.5",
                cy: "2.54562",
                r: "2.5",
                fill: _ctx.isFromNotification ? '#B7B7B7' : '#878787'
              }, null, 8, _hoisted_5)
            ]))
      ], 2)
    ], 42, _hoisted_1),
    (!_ctx.disabled)
      ? (_openBlock(), _createBlock(_component_CustomDropDown, {
          key: 0,
          "id-popover": _ctx.idPopover,
          class: _normalizeClass([
      !_ctx.showMoreActions || !_ctx.overrideHover ? 'tw-invisible' : '',
      _ctx.dropdownClass,
    ]),
          "custom-class": _ctx.customClass,
          "show-acction-click": true,
          placement: _ctx.placement,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal(false)))
        }, _createSlots({ _: 2 }, [
          (_ctx.showMoreActions)
            ? {
                name: "default",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["id-popover", "class", "custom-class", "placement"]))
      : _createCommentVNode("", true)
  ], 64))
}